import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=3148cca2&scoped=true"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"
import style0 from "./SearchHistory.vue?vue&type=style&index=0&id=3148cca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148cca2",
  null
  
)

export default component.exports